export * from './entity-detail-header.component';
